<template>
  <div class="home">
    <div class="slider">
      <v-carousel
        :height="$vuetify.breakpoint.smAndDown ? 300 : 600"
        continuous
        cycle
        show-arrows-on-hover
      >
        <v-carousel-item v-for="(slide, i) in sliderAsObject" :key="i">
          <v-img
            :src="slide.src"
            max-width="100%"
            :height="$vuetify.breakpoint.smAndDown ? 300 : 600"
          />
          <div class="slide-text">{{ slide.text }} ({{ slide.year }})</div>
        </v-carousel-item>
      </v-carousel>
    </div>
    <quote class="quote-top"
      >Aller Abschied ist schwer, aber bei dir ist er besonders schwer!</quote
    >
    <div class="home-news-container">
      <v-card class="mx-auto home-news" elevation="5">
        <v-card-text class="body-1 home-news-text">
          <p>Lieber Jannik,</p>
          <p>
            es ist schwer in Worte zu fassen, wie sehr wir itdesigner dich
            vermissen werden. Mit deiner Leidenschaft, deinem Engagement und
            deinem ständigen Streben nach Pragmatismus hast du uns alle
            inspiriert.
          </p>
          <p>
            Wir hoffen du schaust mal wieder in Deutschland vorbei und dann
            gehen wir sehr gerne mit dir gemeinsam im
            <a href="https://burger.place" target="_blank">burger.place</a>
            essen.
          </p>
          <p>
            Materielle Geschenke sind für Minimalisten ja eher Balast, daher
            wollen wir es dir selbst überlassen dir ein Andenken mit den
            gesammelten <DynamicNumber delay="100" value="150" /> € zu suchen,
            das dich immer an uns erinnert.
          </p>
          <p>
            Mach's gut, Jannik. Wir wünschen dir alles Gute auf deinem weiteren
            Weg.
          </p>
          <p>Mit herzlichen Grüßen</p>
          <People />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<style scoped>
.home {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.quote-top {
  padding-top: 8px;
}

.slider {
  align-self: center;
  width: 800px;
  max-width: 100%;
}

.slide-text {
  background-color: rgba(255, 255, 255, 0.6);
  position: absolute;
  padding: 5px;
  border-radius: 5px;
  top: 16px;
  left: 16px;
}

.home-news-container {
  max-width: 816px;
  padding: 8px;
}

.home-news-text {
  text-align: left;
}
</style>

<script>
import Quote from "../app/Quote";
import "video.js/dist/video-js.css";
import People from "@/home/People.vue";
import { shuffle } from "@/home/shuffle";
import DynamicNumber from "@/app/DynamicNumber.vue";

const sliderAsObject = shuffle([
  { src: "images/DSC_9423.jpg", text: "Weihnachtsfeier", year: 2015 },
  {
    src: "images/DSCF8057.JPG",
    text: "Richtfest des Bürogebäudes",
    year: 2016
  },
  {
    src: "images/IMGP5122.jpg",
    text: "Ankündigung der Festanstellung am Quartalstreffen",
    year: 2017
  },
  {
    src: "images/20170623.jpg",
    text: "Beim Firmenausflug nach Lissabon",
    year: 2017
  },
  { src: "images/DSC00080.JPG", text: "Beim Tischkickerturnier", year: 2018 },
  {
    src: "images/DSC_5040.jpg",
    text: "Beim Firmenausflug in Freiburg",
    year: 2018
  },
  {
    src: "images/DSC_8071.jpg",
    text: "Beim Firmenausflug in Paris",
    year: 2019
  },
  {
    src: "images/cart-fahren.jpeg",
    text: "Team Platform beim Kart fahren",
    year: 2021
  },
  {
    src: "images/burger.jpeg",
    text: "Beim Burger essen",
    year: 2021
  },
  {
    src: "images/DSC_5153.JPG",
    text: "Beim Firmenausflug in Sonthofen",
    year: 2022
  },
  {
    src: "images/2022-07-09 - Reactory Grillen (2).jpg",
    text: "Reactory Grillen",
    year: 2022
  },
  {
    src: "images/2022-10-27 - Gather.png",
    text: "Halloween Refinement",
    year: 2022
  },
  {
    src: "images/animierter-jannik.png",
    text: "Daily",
    year: 2023
  },
  {
    src:
      "images/2023-06-13 - itdesign Core Product Kanu fahren auf der Donau (14).jpg",
    text: "Core Product Kanufahren",
    year: 2023
  },
  {
    src: "images/team-reactor-at-work.jpeg",
    text: "Team Reactor am Bürotag",
    year: 2023
  },
  { src: "images/team-reactor-2.png", text: "Team Reactor", year: 2023 }
]);

export default {
  name: "home",
  components: {
    DynamicNumber,
    People,
    Quote
  },
  data() {
    return {
      sliderAsObject
    };
  }
};
</script>
